import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content sub" }
const _hoisted_4 = {
  key: 0,
  class: "loading-indicator",
  style: {"text-align":"center","padding":"20px"}
}
const _hoisted_5 = {
  key: 1,
  class: "error-message",
  style: {"text-align":"center","padding":"20px","color":"red"}
}
const _hoisted_6 = {
  key: 2,
  class: "glores-B-list-type1"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 3,
  class: "pagination-controls",
  style: {"margin-top":"15px","text-align":"center"}
}
const _hoisted_9 = { style: {"margin":"0 10px"} }
const _hoisted_10 = {
  key: 0,
  class: "order-detail-modal-content",
  style: {"overflow-y":"auto","max-height":"calc(600px - 150px)"}
}
const _hoisted_11 = {
  key: 0,
  style: {"margin-top":"20px"}
}
const _hoisted_12 = {
  key: 1,
  style: {"margin-top":"20px","text-align":"center","color":"#888"}
}
const _hoisted_13 = {
  key: 2,
  style: {"margin-top":"20px"}
}
const _hoisted_14 = {
  key: 1,
  style: {"text-align":"center","padding":"20px"}
}
const _hoisted_15 = { style: {"width":"100%","text-align":"center"} }

import { ref, onMounted, h, computed, watch } from "vue";
import MyPageSidebar from "@/views/member/MypageSidebar.vue"; // MyPageSidebar.vue 오타 수정 가능성 (MypageSidebar -> MyPageSidebar)
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import {
  NDataTable,
  NButton,
  NSpace,
  useMessage,
  NModal,
  NDescriptions,
  NDescriptionsItem,
  NCard,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import { getCallable, makeCallApiParam } from "@/config/env";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";
import { useRouter } from "vue-router";
import { getOrderStatusString } from "@/composables/useOrderForm";
import { Order } from "@/model/order";
import { useAuth } from "@/composables/useAuth";
import { usePagination } from "@/composables/usePagination";
import { NSpin } from "naive-ui"; // NSpin 임포트 추가

const getMyOrders = "getMyOrders";
const pageSize = 10; // 페이지 크기를 상수로 정의


export default /*@__PURE__*/_defineComponent({
  __name: 'PersonalOrder',
  setup(__props) {

const { isLoggedIn } = useAuth();

const message = useMessage();
const router = useRouter();

const pageLoading = ref(false);
// const listLoading = ref(false);
// const error = ref<string | null>(null);
// const orders = ref<Order[]>([]);

const showOrderDetailModal = ref(false);
const selectedOrderDetail = ref<Order | null>(null);
const getCallApiCallable = getCallable("callApi");
const searchQuery = ref(""); // 검색어 상태 추가
const {
  paginatedItems: orders,
  listLoading,
  error,
  currentPage,
  hasNextPage,
  goToNextPage: composableGoToNextPage,
  goToPreviousPage: composableGoToPreviousPage,
  refreshData: composableRefreshItems, // Renamed for clarity
} = usePagination<Order, { searchKey?: string; searchValue?: string }>(
  async (params) =>
    getCallApiCallable(
      makeCallApiParam(getMyOrders, {
        ...params,
        searchKey: "title",
        searchValue: searchQuery.value,
        type: constant.orderType.INDIVISUAL,
      })
    ),
  pageSize
);

watch(
  isLoggedIn,
  (newValue) => {
    if (newValue === false) {
      router.push({ name: "Home" });
    }
  },
  { immediate: true }
);

const columns = computed(() => [
  {
    title: "피검자명",
    titleAlign: "center",
    align: "center",
    key: "examinee_name",
    render: (row: Order) => {
      return row.products![0].projects![0].examinees![0].name;
    },
  },
  {
    title: "신청일",
    titleAlign: "center",
    align: "center",
    key: "createdDate",
    render: (row: Order) =>
      common.getYYYYMMDD2(new Date(Number(row.createdDate))), // formatDate 함수 필요
  },
  {
    title: "상세보기",
    key: "detailView",
    titleAlign: "center",
    align: "center",
    render: (row: Order) => {
      return h(
        NButton,
        {
          size: "small",
          type: "default",
          onClick: () => viewOrderDetails(row),
        },
        { default: () => "상세보기" }
      );
    },
  },
  {
    title: "진행상태", // 병합된 상위 헤더
    key: "actions",
    titleAlign: "center",
    align: "center",
    // width: 450, // 필요시 너비 조절
    children: [
      {
        title: "", // 하위 헤더 텍스트를 빈 문자열로 설정하여 숨김
        key: "status_stepper",
        titleAlign: "center",
        align: "center",
        width: 300,
        render: (row: Order) => {
          const statusSteps = [
            {
              key: "ready",
              label: "검사 준비",
              statuses: [constant.orderStatus.READY],
              iconText: "1",
            },
            {
              key: "in_progress",
              label: "검사 진행중",
              statuses: [constant.orderStatus.ING],
              iconText: "2",
            },
            {
              key: "completed",
              label: "검사 완료",
              statuses: [constant.orderStatus.COMPLETED],
              iconText: "3",
            },
          ];

          let actualCurrentStepIndex = -1;
          statusSteps.forEach((step, index) => {
            if (step.statuses.includes(row.status)) {
              actualCurrentStepIndex = index;
            }
          });

          const stepNodes: any[] = [];
          statusSteps.forEach((step, index) => {
            let stepClass = "pending";
            if (actualCurrentStepIndex !== -1) {
              if (index < actualCurrentStepIndex) {
                stepClass = "completed";
              } else if (index === actualCurrentStepIndex) {
                stepClass = "current";
              }
            }

            stepNodes.push(
              h("div", { class: `step-item ${stepClass}` }, [
                h("div", { class: "step-icon-container" }, step.iconText),
                h("div", { class: "step-label" }, step.label),
              ])
            );

            if (index < statusSteps.length - 1) {
              let connectorClass =
                index < actualCurrentStepIndex ? "completed" : "pending";
              stepNodes.push(
                h("div", { class: `step-connector ${connectorClass}` })
              );
            }
          });
          return h("div", { class: "status-stepper" }, stepNodes);
        },
      },
      {
        title: "", // 하위 헤더 텍스트를 빈 문자열로 설정하여 숨김
        key: "status_actions",
        width: 150,
        titleAlign: "center",
        align: "center",
        render(row: Order) {
          const buttons: any = [];
          if (row.status === constant.orderStatus.READY) {
            buttons.push(
              h(
                NButton,
                {
                  size: "small",
                  type: "primary",
                  ghost: true,
                  onClick: () => gotoOrderProjectDetail(row.SK),
                },
                { default: () => "진단정보 확인" }
              )
            );
          } else if (row.status === constant.orderStatus.ING) {
            buttons.push(
              h(
                NButton,
                {
                  size: "small",
                  type: "info",
                  onClick: () => gotoOrderProjectDetail(row.SK),
                },
                { default: () => "진단현황 확인" }
              )
            );
          } else if (row.status === constant.orderStatus.COMPLETED) {
            buttons.push(
              h(
                NButton,
                {
                  size: "small",
                  type: "info",
                  ghost: true,
                  onClick: () => gotoOrderProjectDetail(row.SK),
                },
                { default: () => "진단결과 조회" }
              )
            );
          }
          // 상세 보기 모달을 여는 버튼은 별도 컬럼에 있으므로 여기서는 제외
          return h(NSpace, { justify: "center" }, () => buttons);
        },
      },
    ],
  },
]);

async function wrappedRefreshItems() {
  await composableRefreshItems();
}

async function wrappedGoToNextPage() {
  if (hasNextPage.value) {
    await composableGoToNextPage();
  }
}

async function wrappedGoToPreviousPage() {
  if (currentPage.value > 1) {
    await composableGoToPreviousPage();
  }
}

// async function fetchUserOrders() {
//   listLoading.value = true;
//   error.value = null;
//   try {
//     const result = await getUserOrdersCallable();
//     orders.value = common.getItemListFromFunctionResult(result) as Order[];
//   } catch (err: any) {
//     console.error("검사 신청 목록 로딩 실패:", err);
//     error.value = "검사 신청 목록을 불러오는데 실패했습니다.";
//     orders.value = [];
//   } finally {
//     listLoading.value = false;
//   }
// }

function viewOrderDetails(order: Order) {
  selectedOrderDetail.value = order;
  showOrderDetailModal.value = true;
}

function gotoOrderProjectDetail(orderSK: string) {
  router.push({
    name: USER_ROUTES.Mypage.Order.Personal.Detail.Name,
    params: { SK: orderSK },
  });
}

onMounted(() => {
  wrappedRefreshItems();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(Loading, null, null, 512), [
      [_vShow, pageLoading.value]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MyPageSidebar),
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("h1", { class: "sub_subject" }, [
          _createTextVNode("진단검사"),
          _createElementVNode("span")
        ], -1)),
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "glores-B-list-h2" }, [
          _createElementVNode("div", { class: "h-left" })
        ], -1)),
        (_unref(listLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 검사 신청 목록을 불러오는 중... "))
          : _createCommentVNode("", true),
        (_unref(error))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(error)), 1))
          : _createCommentVNode("", true),
        (!_unref(listLoading) && !_unref(error))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_unref(orders).length > 0)
                ? (_openBlock(), _createBlock(_unref(NDataTable), {
                    key: 0,
                    class: "personal-order-table",
                    columns: columns.value,
                    data: _unref(orders),
                    pagination: false,
                    bordered: false,
                    "single-line": false
                  }, null, 8, ["columns", "data"]))
                : (_openBlock(), _createElementBlock("ul", _hoisted_7, _cache[3] || (_cache[3] = [
                    _createElementVNode("li", { class: "none-data" }, "등록된 검사 신청 없습니다.", -1)
                  ])))
            ]))
          : _createCommentVNode("", true),
        (_unref(orders).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_unref(NButton), {
                onClick: wrappedGoToPreviousPage,
                disabled: _unref(currentPage) === 1,
                style: {"margin-right":"8px"}
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode(" 이전 페이지 ")
                ])),
                _: 1
              }, 8, ["disabled"]),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(currentPage)) + " 페이지", 1),
              _createVNode(_unref(NButton), {
                onClick: wrappedGoToNextPage,
                disabled: !_unref(hasNextPage)
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode(" 다음 페이지 ")
                ])),
                _: 1
              }, 8, ["disabled"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_unref(NModal), {
      show: showOrderDetailModal.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((showOrderDetailModal).value = $event)),
      preset: "card",
      style: {"width":"800px","max-width":"90vw","max-height":"600px"},
      title: "검사 신청 상세 정보",
      bordered: true,
      closable: true,
      "mask-closable": true,
      onAfterLeave: _cache[2] || (_cache[2] = ($event: any) => (selectedOrderDetail.value = null))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_unref(NButton), {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showOrderDetailModal.value = false))
          }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createTextVNode("닫기")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (selectedOrderDetail.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_unref(NDescriptions), {
                "label-placement": "left",
                bordered: "",
                column: 2,
                size: "small",
                title: "검사 기본 정보"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NDescriptionsItem), { label: "총 금액" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString((selectedOrderDetail.value.totalPrice || 0).toLocaleString()) + "원", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NDescriptionsItem), { label: "상태" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getOrderStatusString)(selectedOrderDetail.value.status)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NDescriptionsItem), { label: "신청일" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(selectedOrderDetail.value.createdDate
                ? common.getYYYYMMDD2(
                    new Date(Number(selectedOrderDetail.value.createdDate))
                  )
                : "N/A"), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NDescriptionsItem), { label: "수신자 이메일" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(selectedOrderDetail.value.receiver_email || "N/A"), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NDescriptionsItem), { label: "피검자명" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(selectedOrderDetail.value.products![0].projects![0].examinees![0]
                .name || "N/A"), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (
            selectedOrderDetail.value.products &&
            selectedOrderDetail.value.products.length > 0
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _cache[8] || (_cache[8] = _createElementVNode("h4", { style: {"margin-bottom":"10px","font-size":"1.1em"} }, "신청 상품", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedOrderDetail.value.products, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.SK || `product-${index}`,
                        class: "product-item-card-modal"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(item.name), 1)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, " 신청에 포함된 상품이 없습니다. ")),
              (selectedOrderDetail.value.payment_method)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _cache[10] || (_cache[10] = _createElementVNode("h4", { style: {"margin-bottom":"10px","font-size":"1.1em"} }, "결제 정보", -1)),
                    _createVNode(_unref(NDescriptions), {
                      "label-placement": "left",
                      bordered: "",
                      column: 1,
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NDescriptionsItem), { label: "결제 방법" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrderDetail.value.payment_method.type === "bank_deposit"
                  ? "계좌이체"
                  : selectedOrderDetail.value.payment_method.type || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "입금자명" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrderDetail.value.payment_method.deposit_name || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "입금 예정일" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrderDetail.value.payment_method.bank_date
                  ? common.getYYYYMMDD2(
                      new Date(selectedOrderDetail.value.payment_method.bank_date)
                    )
                  : "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "결제 계좌" }, {
                          default: _withCtx(() => _cache[9] || (_cache[9] = [
                            _createTextVNode(" 우리은행 : 1005-104-783814, 예금주: (주)코코랩 ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, " 상세 정보를 불러오는 중이거나, 선택된 상품이 없습니다. "))
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})